<template>
  <div class="contact-container">
    <div class="title">{{$t('home.Contacts')}}</div>
    <div class="item-container">
      <div
        class="item"
        v-for="(item, index) in contactList"
        :key="index"
        @click="handleItemClick(item.uid)"
      >
        <slot :contact="item"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('collaborator')
export default {
  name: 'contact',
  props: {
    contactList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  inject: ['selectedKeysContext'],
  methods: {
    ...mapActions(['queryUserInfo']),
    handleItemClick (uid) {
      this.selectedKeysContext && this.selectedKeysContext.func && typeof this.selectedKeysContext.func === 'function' && this.selectedKeysContext.func(uid)
      this.queryUserInfo(uid)
    }
  }
}
</script>

<style scoped lang="less">
.contact-container {
  .title {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #F7F8FA;
    font-size: 16px;
    font-weight: 500;
    color: #999B9F;
    padding-left: 30px;
  }
  .item-container {
    padding: 0 8px;
  }
  .item {
    display: flex;
    align-items: center;
    height: 40px;
    background: #fff;
    padding-left: 40px;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    &:hover {
      cursor: pointer;
      background-color: #F3F6FB;
    }
    .mobile-container {
      height: 40px;
      .name {
        height: 22px;
        line-height: 22px;
      }
      .mobile {
        font-size: 12px;
        font-weight: 400;
        color: #999B9F;
      }
    }
  }
}
</style>
